module.exports = __webpack_public_path__ + "img/cobalt_family_room_1.jpg";